module.exports = __webpack_public_path__ + "f8f62ba6bf9724200587100dfd64c715.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-jester-s.png
// module id = 2547
// module chunks = 0